import React, { Component, Fragment } from "react";
import { HotTable } from "@handsontable/react";
import Handsontable from "handsontable";
import "handsontable/dist/handsontable.full.css";
import { connect } from "react-redux";
import * as actions from "../../actions/users/getUserActions";
import { fetchActiveCategories } from "../../actions/categories/fetchActiveCategories";
import moment from "moment";
import { bindActionCreators } from "redux";
import { colWidths } from "../../Constants/colWidths";
import { colHeaders } from "../../Constants/colHeaders";
import { filterEnabledCols } from "../../Constants/filterEnabledCols";
import DEFAULTS from "../../Constants/lookupDefaultValues";
import setDropdownValues from "../../Common/Utility/setDropdownValues";
import MultiSelectEditor from "../../Common/MultiSelectEditor/MultiSelectEditor";
import customDropdownRenderer from "../../Common/MultiSelectEditor/CustomDrodownRender";
import * as ccr from "../../Common/Utility/customCellRender";
import { Dimmer, Modal, Loader, Grid, Button } from "semantic-ui-react";
import { Redirect } from "react-router-dom";
import API from "../../Constants/API";
import * as usersServices from "../../services/users/index";
import WarningMessageWithCloseOption from "./../../Common/Layout/WarningMessageWithCloseOption";


import XLSX from "xlsx";
import {
    createNotification,
    NOTIFICATION_TYPE_SUCCESS,
    NOTIFICATION_TYPE_WARNING,
    NOTIFICATION_TYPE_ERROR
} from "react-redux-notify";
try {
    var userDetails = atob(localStorage.getItem("userDetails"));

    if (userDetails) {
        userDetails = JSON.parse(userDetails);
    }
} catch (e) {
    window.location.reload();
}

//  let logindetails = this.getFullName(userDetails.UserContext);

var FIRM_ID = null;
var logginedUser = null;
var manageUserRights = null;
var manageUserRightsAccess = null;
var manageUserRightsModuleId = null;

//Check globale user
var rightsDetails = null;
var BRANCH_ID = null;
var RIGHT_ACCESS = null;
var MODULE_ID = null;
var GLOBAL_USER = null;

FIRM_ID = userDetails ? userDetails.UserContext.firmId : 0;
logginedUser = userDetails.UserContext.userId;
// Check Role based acces for the manage users landing page
// Rights Ids :: ModuleId = 4
manageUserRights = userDetails.Rights.filter(x => x.module_id == 4);
manageUserRightsAccess = manageUserRights[0].access;
manageUserRightsModuleId = manageUserRights[0].module_id;

//Check globale user
rightsDetails = userDetails.Rights.filter(x => x.module_id == 8);
BRANCH_ID = userDetails.UserContext.locationId;
RIGHT_ACCESS = rightsDetails[0].access;
MODULE_ID = rightsDetails[0].module_id;
var GLOBAL_USER = "N";
if (RIGHT_ACCESS == 1 && MODULE_ID == 8) {
    GLOBAL_USER = "Y";
}

class UserTable extends Component {
  isSelectAllChecked = false;
  isEventBySelectAll = false;
  filterUserStatus = true;
  constructor(props) {
      super(props);
      this.FirmLinkedToAxcess = userDetails && userDetails.UserContext.FirmLinkedToAxcess ? userDetails.UserContext.FirmLinkedToAxcess : false;

        String.prototype.replaceAll = function (search, replacement) {
            var target = this;
            return target.split(search).join(replacement);
        };

        this.validationNotification = {
            type: NOTIFICATION_TYPE_ERROR,
            duration: 5000,
            canDismiss: true,
            showCloseAllBtn: true
        };
        // console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
        this.hotTableComponent = React.createRef();
        this.state = {
            selectedRows: [],
            selectedUsersCount: 0,
            changedRows: [],
            showLicenseError: false,
            activatedUsersList: []
        };

        this.settings = {
            licenseKey: "0b014-a057a-62a00-d4631-40c07",
            rowHeaders: true,
            className: "htLeft",
            fillHandle: {
                direction: "vertical",
                autoInsertRow: false
            },
            // minSpareRows: 1, //add next row automatically when prev row filled
            fixedColumnsLeft: 6,
            columnSorting: true,
            multiColumnSorting: false,
            // multiColumnSorting: {
            //   sortEmptyCells: true,
            //   indicator: true,
            //   headerAction: true,
            //   initialConfig: [{
            //     column: 2,
            //     sortOrder: 'asc'
            //   }, {
            //     column: 5,
            //     sortOrder: 'asc'
            //   },

            //   ]
            // },
            manualColumnResize: true,
            manualRowResize: true,
            filters: filterEnabledCols,
            dropdownMenu: ["filter_action_bar", "filter_by_value"],
            afterGetColHeader: this.afterGetColHeaderHandler,
            observeDOMVisibility: true,
            observeChanges: true,
            stretchH: "all",
            manualColumnMove: true,
            cells: this.cells.bind(this),
            // hiddenColumns: {
            //   columns: [2],
            //   indicators: false
            // },
            headerTooltips: {
                rows: false,
                columns: true,
                onlyTrimmed: false
            },
        };

        this.columns = [
            {
                data: "selected",
                type: "checkbox",
                columnSorting: {
                    indicator: false,
                    headerAction: false,
                    compareFunctionFactory: function compareFunctionFactory() {
                        return function comparator() {
                            return 0; // Don't sort the first visual column.
                        };
                    }
                }
                // checkedTemplate: "yes",
                // uncheckedTemplate: "no",
            },
            //{ data: "user_id" },
            {
                data: "branch_name",
                allowEmpty: false,
                readOnly: GLOBAL_USER === "Y" ? false : true,
                allowInvalid: false,
                renderer: customDropdownRenderer,
                editor: MultiSelectEditor,
                selector: "firmBranches",
                properties: { id: "id", label: "name", value: "name" },
                selectOptions: {
                    data: null
                }
            },
            {
                data: "first_name",
                allowEmpty: false,
                allowInvalid: true,
                renderer: ccr.firstnameRender.bind(this)
            },

            {
                data: "middle_name",
                renderer: ccr.disableRender.bind(this)
            },
            {
                data: "last_name",
                allowEmpty: false,
                allowInvalid: false,
                renderer: ccr.disableRender.bind(this)
            },
            {
                data: "generation_type",
                renderer: ccr.customDropdownRenderer_DisableCheck.bind(this),
                editor: MultiSelectEditor,
                selectOptions: {
                    multiple: false,
                    data: null
                },
                selector: "generationList",
                properties: { id: "name", label: "name", value: "name" }
            },
            {
                data: "email_id",
                allowEmpty: false,
                allowInvalid: false,
                renderer: ccr.disableRender.bind(this)
            },
            {
                data: "phone_number",
                allowEmpty: false,
                allowInvalid: false,
                renderer: ccr.phoneRender.bind(this)
            },
            {
                data: "task_location_names",
                renderer: customDropdownRenderer,
                editor: MultiSelectEditor,
                selectOptions: {
                    multiple: true,
                    data: null
                },
                selector: "firmBranches",
                properties: { id: "id", label: "name", value: "name" }
            },
            {
                data: "department_names",
                renderer: customDropdownRenderer,
                editor: MultiSelectEditor,
                selectOptions: {
                    multiple: true,
                    data: null
                },
                selector: "department",
                properties: { id: "id", label: "name", value: "name" }
            },
            {
                data: "account_disabled",
                renderer: ccr.customDropdownRenderer_DisableCheck.bind(this),
                editor: MultiSelectEditor,
                selectOptions: {
                    data: [
                        {
                            id: "1",
                            label: "Active",
                            value: "Active"
                        },
                        {
                            id: "2",
                            label: "Inactive",
                            value: "Inactive"
                        }
                    ]
                }
            },
            {
                data: "pinned_views_for_myview",
                renderer: customDropdownRenderer,
                editor: MultiSelectEditor,
                selectOptions: {
                    multiple: true,
                    data: null
                },
                selector: "pageDetails",
                properties: { id: "id", label: "name", value: "name" }
            },
            {
                data: "default_myview_name",
                renderer: customDropdownRenderer,
                editor: MultiSelectEditor,
                selectOptions: {
                    multiple: false,
                    data: null
                },
                selector: "pageDetails",
                properties: { id: "id", label: "name", value: "name" }
            },
            {
                data: "default_category",
                renderer: customDropdownRenderer,
                editor: MultiSelectEditor,
                selectOptions: {
                    multiple: false,
                    data: null
                },
                selector: "defaultCategory",
                properties: { id: "id", label: "name", value: "name" }
            },
            // {
            //   data: "parttime_employee",
            //   type: "checkbox",
            //   checkedTemplate: "1",
            //   uncheckedTemplate: "0"
            // },
            {
                data: "employee_id",
                allowEmpty: false,
                renderer: ccr.disableRender.bind(this)
                //allowInvalid: false,
            },
            {
                data: "belongsto_group_names",
                renderer: customDropdownRenderer,
                editor: MultiSelectEditor,
                selectOptions: {
                    multiple: true,
                    data: null
                },
                selector: "rightsGroupNames",
                properties: { id: "id", label: "name", value: "name" }
            },
            {
                data: "title_or_level_names",
                renderer: ccr.customDropdownRenderer_DisableCheck.bind(this),
                editor: MultiSelectEditor,
                selectOptions: {
                    data: null
                },
                selector: "titleLevelList",
                properties: { id: "id", label: "name", value: "name" }
            },
            {
                data: "ip_from",
                readOnly: true
            },
            {
                data: "industry_names",
                renderer: customDropdownRenderer,
                editor: MultiSelectEditor,
                selectOptions: {
                    multiple: true,
                    data: null
                },
                selector: "industry",
                properties: { id: "id", label: "name", value: "name" }
            },
            {
                data: "niche_or_group_names",
                renderer: customDropdownRenderer,
                editor: MultiSelectEditor,
                selectOptions: {
                    multiple: true,
                    data: null
                },
                selector: "nicheGroups",
                properties: { id: "id", label: "name", value: "name" }
            },
            {
                data: "expertise_names",
                renderer: ccr.customDropdownRenderer_DisableCheck.bind(this),
                editor: MultiSelectEditor,
                selectOptions: {
                    multiple: true,
                    data: null
                },
                selector: "expertise",
                properties: { id: "id", label: "name", value: "name" }
            },
            // { data: "residenceCity", type: "text" },
            {
                data: "primary_role_name",
                renderer: customDropdownRenderer,
                editor: MultiSelectEditor,
                selectOptions: {
                    data: null
                },
                selector: "rolesDetails",
                properties: { id: "id", label: "name", value: "name" }
            },
            {
                data: "secondary_role_name",
                renderer: customDropdownRenderer,
                editor: MultiSelectEditor,
                selectOptions: {
                    data: null
                },
                selector: "rolesDetails",
                properties: { id: "id", label: "name", value: "name" }
            },
            {
                data: "wrk_exp_begindate",
                type: "date",
                dateFormat: "MM/DD/YY",
                datePickerConfig: {
                    maxDate: new Date()
                },
                correctFormat: true,
            },
            {
                data: "yearsofexp",
                allowEmpty: false,
                allowInvalid: false
            },
            {
                data: "primaryBilling_Rate",
                allowEmpty: false,
                allowInvalid: false
            },
            {
                data: "secondaryBilling_Rate",
                allowEmpty: false,
                allowInvalid: false
            },
            {
                data: "last_login",
                allowEmpty: true,
                readOnly: true,
                type: "date",
                dateFormat: "MM/DD/YY hh:mm A",
                allowInvalid: false,
            }
        ];
    }
    disableHeaderCheckBox(isDisabled) {
        let checkboxOption = "";
        checkboxOption =
            "<input type='checkbox' class='checker htCheckboxRendererInput' data-row='-1' data-col='0' title='Select Up to first 50'";

        checkboxOption += isDisabled ? "disabled=true" : "";
        checkboxOption += ">";
        colHeaders[0] = checkboxOption;

    }
    setCheckBoxHeaderOptionFromSingleSelect(isALLSelected) {
        let checkboxOption = "";
        checkboxOption =
            "<input type='checkbox' class='checker htCheckboxRendererInput' data-row='-1' data-col='0' title='Select Up to first 50'";
        checkboxOption += isALLSelected ? "checked=true" : "";
        checkboxOption += ">";
        colHeaders[0] = checkboxOption;
    }
    setCheckBoxHeaderOption() {
        let checkboxOption = "";
        this.isSelectAllChecked = !this.isSelectAllChecked;
        checkboxOption =
            "<input type='checkbox' class='checker htCheckboxRendererInput' data-row='-1' data-col='0' title='Select Up to first 50'";
        checkboxOption += this.isSelectAllChecked ? "checked=true" : "";
        checkboxOption += ">";
        colHeaders[0] = checkboxOption;
    }
    afterOnCellMouseDownHandler(event, cellCoords, TD) {
        if (
            !this.hotTableComponent ||
            !this.hotTableComponent.current ||
            !this.hotTableComponent.current.hotInstance
        ) {
            return;
        }
        const hot = this.hotTableComponent.current.hotInstance;
        if (cellCoords.row === -1 && cellCoords.col === 0) {
            this.setCheckBoxHeaderOption();
            let getData = hot.getData();
            this.isEventBySelectAll = true;
            if (getData.length >= 50) {
                for (var i = 0; i < 50; i++) {
                    getData[i][0] = this.isSelectAllChecked;
                }
                hot.populateFromArray(0, 0, getData, 49, 1);
            } else {
                for (var i = 0; i < getData.length; i++) {
                    getData[i][0] = this.isSelectAllChecked;
                }
                hot.populateFromArray(0, 0, getData, getData.length - 1, 1);
            }
        }
    }



    cells(row, col, prop) {

        const cellProperties = {};
        if (this.props.isEdited) {
            if (col === 0) {
                cellProperties.readOnly = true;
            }
        }
        return cellProperties;
    }


    excelMapper() {
        // Default header key map
        let defaults = {
            "Primary Location": "branch_id",
            "First Name": "first_name",
            "Middle Name/Initial": "middle_name"
        };
        // Object.keys(defaults).map(item => {
        //   let a = {};
        //   if(arr.includes(item)) {
        //     a[item] = defaults[item]
        //     return a;
        //   } else {
        //     return false;
        //     }}).filter(el => el);
        //map with lookups
        //flatten maps into array of arrays
    }

    exportToExcel() {
        var wb = XLSX.utils.book_new();
        var ws_name = "User Details";
        /* make worksheet */
        var data = this.hotTableComponent.current.hotInstance.getData();
        let colH = colHeaders.slice(1);

        let filename = `User details exported on ${moment().format("MMDDYY hhmmss")}.xlsx`;
        const replaceBeforeSending = (el, colNum) => {
            if (colNum >= 24) el[colNum] = el[colNum].toString();
            else el[colNum] = el[colNum].replaceAll("|", ",");
            return el[colNum];
        };

        // data.map(el => {
        //   el[14] = el[14] == "1" ? "Y" : "N";
        // });

        data.map(el => {
            replaceBeforeSending(el, 8);
            replaceBeforeSending(el, 9);
            replaceBeforeSending(el, 11);
            replaceBeforeSending(el, 15);
            replaceBeforeSending(el, 18);
            replaceBeforeSending(el, 19);
            replaceBeforeSending(el, 20);
            replaceBeforeSending(el, 25);
            replaceBeforeSending(el, 26);
        });

        let finalDatatoExport = data.map(item => item.slice(1));
        var ws = XLSX.utils.aoa_to_sheet([colH, ...finalDatatoExport]);

        XLSX.utils.sheet_set_range_style(
            ws, // worksheet
            "A1:AB1", // range
            {
                // style object
                fgColor: { rgb: "#647998" },
                color: { rgb: 0xffffff }
            }
        );

        /* Add the worksheet to the workbook */
        XLSX.utils.book_append_sheet(wb, ws, ws_name);
        XLSX.writeFile(wb, filename, { cellStyles: true });
        this.props.actions.exportToExcel(false);
    }

    handleClearFilters() {
        if (this.hotTableComponent.current === null) return;
        const hot = this.hotTableComponent.current.hotInstance;
        var filterPlugin = hot.getPlugin("Filters");
        filterPlugin.clearConditions();
        filterPlugin.filter();
        this.setCheckBoxHeaderOptionFromSingleSelect(false);
        this.disableHeaderCheckBox(this.props.isEdited ? true : false)
        this.isSelectAllChecked = false;
        this.props.actions.clearAllFilters(false, this.props.allUsers);
    }

    sortSelectedUsersToTop() {
        //console.log("################### sortSelectedUsersToTop")
        if (this.hotTableComponent.current === null) return;
        const hot = this.hotTableComponent.current.hotInstance;
        var filterPlugin = hot.getPlugin("Filters");
        filterPlugin.clearConditions();
        filterPlugin.filter();
    }

    afterGetColHeaderHandler(col, TH) {
        let buttonClassName = "changeType";
        let existingButton = TH.querySelector("." + buttonClassName);
        let filterEnabledCols = this.getSettings().filters;
        let propName = this.colToProp(col);
        if (existingButton) {
            if (
                Array.isArray(filterEnabledCols) &&
                !filterEnabledCols.includes(propName)
            ) {
                existingButton.parentNode.removeChild(existingButton);
            }
        }
        let nonEditableFields = [-1, 0, 16];
        if (!nonEditableFields.includes(col)) {
            TH.classList.add("editable");
        }
    }
    uniqueValidator(value, callback, oldValue) {
        var emailIds = this.props.allUsers.map(elem => elem.email_id.toUpperCase());
        var index = emailIds.indexOf(oldValue.toUpperCase());
        emailIds.splice(index, 1, oldValue);
        if (emailIds.includes(value.toUpperCase())) {
            value = oldValue;
        }
        return value;
    }

    afterChangeHandler(changes, source) {
        if (
            changes === null ||
            this.hotTableComponent.current === null ||
            source === "loadData"
        )
            return;
        let hot = this.hotTableComponent.current.hotInstance;

        if (source === "populateFromArray") {
            // console.log("populateFromArray", changes, hot.getData())
            //  let first50 = changes.filter(el => el[3] == true);
            let getSelectedData = changes
                .filter(el => el[3] == true)
                .map((el, i) => {
                    // console.log(el[0], hot.getSourceDataAtRow(el[0]));
                    return hot.getSourceDataAtRow(hot.toPhysicalRow(el[0]));
                })
                .map(el => {
                    return {
                        user_id: el.user_id,
                        account_disabled: el.account_disabled
                    };
                });

            const userIds = getSelectedData.map(el => el.user_id);
            const userStatus = getSelectedData.map(el => el.account_disabled);
            if (userIds.length && userStatus.length) {
                this.props.actions.selectedUsers(userIds, userStatus);
            } else {
                this.props.actions.selectedUsers([], []);
            }
        }
        if ((source === "edit" || source === "Autofill.fill") && changes[0][1] === "selected") {
            let uncheckedData = hot.getData().filter(el => el[0] == false);
            if (uncheckedData.length >= 1) {
                this.setCheckBoxHeaderOptionFromSingleSelect(false);
                this.isSelectAllChecked = false;
            } else {
                this.setCheckBoxHeaderOptionFromSingleSelect(true);
                this.isSelectAllChecked = false;
            }

            changes.map(change => {
                let physicalRow = hot.toPhysicalRow(change[0]);
                let newlySelectedUser = this.props.allUsers[physicalRow];
                let selectedUsersData = this.props.selectedUsersIds;
                let selectedUsersStatus = this.props.selectedUsersStatus;

                if (change[3] === true) {
                    let userIndex = selectedUsersData.indexOf(newlySelectedUser.user_id);
                    if (userIndex < 0) {
                        selectedUsersData.push(newlySelectedUser.user_id);
                        selectedUsersStatus.push(newlySelectedUser.account_disabled);
                    }
                } else {
                    let userIndex = selectedUsersData.indexOf(newlySelectedUser.user_id);
                    let statusIndex = selectedUsersStatus.indexOf(newlySelectedUser.account_disabled);
                    if (userIndex > -1) {
                        selectedUsersData.splice(userIndex, 1);
                    }
                    if (statusIndex > -1) {
                        selectedUsersStatus.splice(statusIndex, 1);
                    }
                }

                this.props.actions.selectedUsers(selectedUsersData, selectedUsersStatus);
            });
        }

        if (
            (source === "edit" || source === "Autofill.fill") &&
            changes[0][1] !== "selected"
        ) {
            // [[row, prop, oldVal, newVal], ...]
            changes.map(change => {
                let changedColIndex = hot.propToCol(change[1]);
                let changedRowIndex = change[0];
                let physicalRow = hot.toPhysicalRow(changedRowIndex);
                let updatedUsers = this.props.updatedUsers;
                let updatedUserData = hot.getSourceDataAtRow(physicalRow);
                let index = updatedUsers.findIndex(
                    user => user.user_id == updatedUserData.user_id
                );

                if (change[1] == "account_disabled" && change[2] == "Inactive" && change[3] == "Active") {
                    var activatedUsersObj = {};
                    activatedUsersObj = updatedUserData;
                    activatedUsersObj.OldAccountStatus = change[2];
                    this.state.activatedUsersList.push(activatedUsersObj);
                }
                else if (change[1] == "account_disabled" && change[2] == "Active" && change[3] == "Inactive") {
                    const updatedActivatedUsersList = this.state.activatedUsersList.filter(item => item.user_id !== updatedUserData.user_id);
                    this.setState({ activatedUsersList: updatedActivatedUsersList });
                }

                if (index >= 0) {
                    updatedUsers.splice(index, 1);
                }

                updatedUsers.push({ ...updatedUserData });

                if (change[2] !== change[3]) {
                    this.props.actions.gridUpdate(updatedUsers, true);
                    if (this.props.isEdited) {
                        this.disableHeaderCheckBox(true);
                        this.state.changedRows.push({
                            row: physicalRow,
                            col: changedColIndex
                        });
                        hot.setCellMeta(
                            changedRowIndex,
                            changedColIndex,
                            "className",
                            "editedCellColor"
                        );
                    }
                }
            });
        }

        // default_myview_name set to top of pinned view
        if ((source === "edit" || source === "Autofill.fill") && changes[0][1] === 'default_myview_name') {
            changes.map(change => {

                let oldmyView = change[2];
                let myView = change[3];
                if (!myView) return;
                let pinnedData = hot.getDataAtCell(change[0], 11);

                let values =
                    typeof pinnedData == "string"
                        ? pinnedData.split("|").map(i => (typeof i == "string" ? i.trim() : i))
                        : pinnedData;
                if (!values.includes(myView)) {
                    hot.setDataAtCell(change[0], 12, oldmyView);
                    hot.setCellMeta(
                        change[0],
                        12,
                        "className",
                        ""
                    );
                }


                if ((values.includes(myView)) && values[0] != myView) {
                    let myviewIndex = values.indexOf(myView);
                    if (myviewIndex != -1) {
                        values.splice(myviewIndex, 1);
                    }
                    values.unshift(myView);
                    hot.setDataAtCell(change[0], 11, values.join("|"));
                }

            });
        }

        // remove default myview view if not selected in pinned view
        if ((source === "edit" || source === "Autofill.fill") && changes[0][1] === 'pinned_views_for_myview') {
            changes.map(change => {
                let defaultView = hot.getDataAtCell(change[0], 12);
                let pinnedData = change[3].split("|").filter(el => el != "");

                if (!pinnedData.length) {
                    hot.setDataAtCell(change[0], 11, 'My Tasks');
                }
                else if (!pinnedData.includes(defaultView) || pinnedData[0] != defaultView) {
                    hot.setDataAtCell(change[0], 12, '');
                }
            });
        }

        // if ((source === "edit") && changes[0][1] === 'pinned_views_for_myview') {
        //   changes.map(change => {

        //     let pinnedData = hot.getDataAtCell(change[0], 11).split("|");
        //     console.log("pinnedData", pinnedData)

        //   });
        // }

        hot.render();
    }

    afterLoadDataHandler(initialLoad) {
        //console.log("afterloaddata  ", this.props, !this.props.allUsers.length)
        // //filtering - visible 1/5 rows
        if (
            !this.props.allUsers.length ||
            this.hotTableComponent.current === null
        ) {
            return;
        }
        let hot = this.hotTableComponent.current.hotInstance;

        //console.log("afterLoadDataHandler", this.props.filterUserStatus)
        if (this.filterUserStatus) {
            var filterPlugin = hot.getPlugin("Filters");
            // filterPlugin.addCondition(10, "begins_with", [["ac"]], "conjunction");
            // filterPlugin.addCondition(10, "not_contains", [["in"]], "conjunction");
            filterPlugin.addCondition(10, "by_value", [["Active"]]);
            filterPlugin.filter();
        }
    }

    afterRenderHandler(TD, row, column, prop, value, cellProperties) {
        // console.log("afterRender", value, cellProperties)
        // if (this.hotTableComponent.current != null) {
        //   let hot = this.hotTableComponent.current.hotInstance;
        //   this.state.changedRows.forEach(element => {
        //     let vRow = hot.toVisualRow(element.row);
        //     let vCol = hot.toVisualColumn(element.col);
        //     if (this.props.isEdited) {
        //       hot.setCellMeta(
        //         vRow,
        //         vCol,
        //         "className",
        //         "editedCellColor"
        //       );
        //     }
        //   });
        // }
    }

    afterFilterHandler(conditionsStack) {
        if (this.hotTableComponent.current === null) {
            return;
        }
        let hot = this.hotTableComponent.current.hotInstance;
        let afterFilterRowsCount = hot.getData().length;
        this.props.actions.getRowsCountAfterFilter(afterFilterRowsCount);
        this.filterUserStatus = false;
    }
    locationValidation(changes, type) {
        // empty validation - replaces to old value incase empty
        if (changes[0][3] == "") {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `Branch name should not be empty`,
                ...this.validationNotification
            };

            this.props.createNotification(notifyMsg);
        }
    }
    nameValidation(changes, type) {
        // empty validation - replaces to old value incase empty
        let actualLabel = type === "first_name" ? "First name" : "Last name ";
        if (
            (type === "first_name" || type === "last_name") &&
            changes[0][3] == ""
        ) {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `${actualLabel} should not be empty`,
                ...this.validationNotification
            };
            this.props.createNotification(notifyMsg);
        }
        // length & special characters validation - replaces to old value incase invalid entry
        if (changes[0][3].length > 50) {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `${actualLabel} should not contain more than 50 characters`,
                ...this.validationNotification
            };
            this.props.createNotification(notifyMsg);
        }

        if (
            changes[0][3] &&
            /[^\u0000-\u007F]/.test(changes[0][3])
        ) {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `${actualLabel} should not contain latin special characters`,
                ...this.validationNotification
            };
            this.props.createNotification(notifyMsg);
        }
    }
    initialValidation(changes, type) {
        // length & special characters validation - replaces to old value incase invalid entry
        if (changes[0][3].length > 60) {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `Middle name should not contain more than 60 characters`,
                ...this.validationNotification
            };
            this.props.createNotification(notifyMsg);
        }


        if (
            changes[0][3] &&
            /[^\u0000-\u007F]/.test(changes[0][3])
        ) {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `Middle name should not contain latin special characters`,
                ...this.validationNotification
            };
            this.props.createNotification(notifyMsg);
        }
    }
    workExpDateValidation(changes, type) {
        // length & special characters validation - replaces to old value incase invalid entry
        if (
            changes[0][3] &&
            !/^\d{2}\/\d{2}\/\d{2}$/.test(changes[0][3])
        ) {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `Invalid date`,
                ...this.validationNotification
            };
            this.props.createNotification(notifyMsg);
        }
    }

    // residenceCityValidation(changes, type) {
    //   // length & special characters validation - replaces to old value incase invalid entry
    //   if (changes[0][3].length > 50) {
    //     changes[0][3] = changes[0][2];
    //     const notifyMsg = {
    //       message: `Residence city should not contain more than 50 characters`,
    //       ...this.validationNotification
    //     };
    //     this.props.createNotification(notifyMsg);
    //   }
    // }

    emailValidation(changes, type) {
        // empty validation - replaces to old value incase empty
        if (type === "email_id" && changes[0][3] == "") {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `Email should not be empty`,
                ...this.validationNotification
            };
            this.props.createNotification(notifyMsg);
        }
        // length & special characters validation - replaces to old value incase invalid entry
        if (
            !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                changes[0][3]
            )
        ) {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `Invalid email Id`,
                ...this.validationNotification
            };
            this.props.createNotification(notifyMsg);
        }
    }
    phoneValidation(changes, type) {
        // length & special characters validation - replaces to old value incase invalid entry

        if (
            changes[0][3] &&
            (!/^[-\(\) ]*([0-9][-\(\) ]*){10,15}$|^$/.test(changes[0][3]) || (changes[0][3].length > 20))
        ) {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `Enter valid phone number`,
                ...this.validationNotification
            };
            this.props.createNotification(notifyMsg);
        }
    }
    empidValidation(changes, type) {
      
        // length validation - replaces to old value incase invalid entry
        if (changes[0][3].length > 100) {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `Employee ID should not contain more than 100 characters`,
                ...this.validationNotification
            };
            this.props.createNotification(notifyMsg);
            return;
        }

        // allow letters, digits, and these special chars: . @ # - _ . ' (apostrophe)
        if (!/^(?:[a-zA-Z0-9\s#@_.'-]+)?$/.test(changes[0][3])) {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `Employee ID is not valid.Allowed characters: letters (a-z, A-Z), digits (0-9), and special characters - _ ' @ . # `,
                ...this.validationNotification
            };
            this.props.createNotification(notifyMsg);
        }
    }
    yearsofexpValidation(changes, type) {
        // length & special characters validation - replaces to old value incase invalid entry
        if (!/^([0-9]{1}|[0-9]{2})$|^$/.test(changes[0][3])) {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `Years of experience should contain up to 2 digits `,
                ...this.validationNotification
            };
            this.props.createNotification(notifyMsg);
        }
    }

    pinnedViewCountValidation(changes, type) {
        if (changes[0][3].split("|").length > 7) {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `Users can have up to 7 views pinned to their MyView `,
                ...this.validationNotification
            };
            this.props.createNotification(notifyMsg);
        }
    }
    billingrateValidation(changes, type) {
        let actualLabel =
            type === "primaryBilling_Rate"
                ? "Primary Billing Rate"
                : "Secondary Billing Rate";
        // length & special characters validation - replaces to old value incase invalid entry
        if (!/(^[0-9]{1,9})+(\.[0-9]{1,2})?$|^$/.test(changes[0][3])) {
            changes[0][3] = changes[0][2];
            const notifyMsg = {
                message: `${actualLabel} should contain up to 9 digits `,
                ...this.validationNotification
            };
            this.props.createNotification(notifyMsg);
        }
    }

    onBeforeHotChange(changes, source) {
        // [[row, prop, oldVal, newVal], ...]
        if (
            (source !== "edit" && !changes) ||
            this.hotTableComponent.current === null
        ) {
            return;
        }

        if (
            (source === "edit" || source === "Autofill.fill") &&
            changes[0][1] !== "selected"
        ) {
            changes[0][3] = changes[0][3].replace(/  +/g, ' ');
        }
        switch (changes[0][1]) {
            case "branch_name":
                this.locationValidation(changes, changes[0][1]);
                break;
            case "first_name":
            case "last_name":
                this.nameValidation(changes, changes[0][1]);
                break;
            case "middle_name":
                this.initialValidation(changes, changes[0][1]);
                break;
            case "phone_number":
                this.phoneValidation(changes, changes[0][1]);
                break;
            case "email_id":
                this.emailValidation(changes, changes[0][1]);
                break;

            case "wrk_exp_begindate":
                this.workExpDateValidation(changes, changes[0][1]);
                break;

            case "employee_id":
                this.empidValidation(changes, changes[0][1]);
                break;
            case "yearsofexp":
                this.yearsofexpValidation(changes, changes[0][1]);
                break;

            case "pinned_views_for_myview":
                this.pinnedViewCountValidation(changes, changes[0][1]);
                break;
            // case "residenceCity":
            //   this.residenceCityValidation(changes, changes[0][1]);
            //   break;

            case "primaryBilling_Rate":
            case "secondaryBilling_Rate":
                this.billingrateValidation(changes, changes[0][1]);
                break;
        }
        let hot = this.hotTableComponent.current.hotInstance;
        if (
            source === "Autofill.fill" &&
            (changes[0][1] === "first_name" ||
                changes[0][1] === "last_name" ||
                changes[0][1] === "middle_name" ||
                changes[0][1] === "email_id" ||
                changes[0][1] === "phone_number" ||
                changes[0][1] === "employee_id" ||
                changes[0][1] === "account_disabled" ||
                changes[0][1] === "ip_from")
        ) {
            return false;
        }

        if (source === "edit" && changes[0][1] === "email_id") {
            changes.map(change => {
                let col = hot.propToCol(change[1]);
                let row = change[0];
                let changed = change[3];
                changed = this.uniqueValidator(changed, null, change[2]);
                change[3] = changed;
            });
        }
    }

    getFullName(UserContext) {
        var firmId = UserContext.firmId;
        var userId = UserContext.userId;
        var firstName = UserContext.firstName;
        var lastName = UserContext.lastName;
        var middleName = UserContext.middleName;
        var gen = UserContext.generationType;
        var fullName = lastName + ", " + firstName;
        fullName += middleName ? " " + middleName + "." : "";
        fullName += gen ? " " + gen + "." : "";
        return {
            firmId,
            userId,
            fullName
        };
    }

    componentDidMount() {
        //console.log("componentDidMount");
        window.onbeforeunload = () => {
            if (this.props.isEdited) {
                return "";
            }
        };
        if (this.props.allUsers.length) {
            return;
        }
        var userDetails = atob(localStorage.getItem("userDetails"));
        if (userDetails) {
            try {
                userDetails = JSON.parse(userDetails);
            }
            catch (error) {
                console.error('Invalid JSON input:', error.message);
            }
        } else {
            return;
        }
        FIRM_ID = userDetails ? userDetails.UserContext.firmId : 847;
        logginedUser = userDetails.UserContext.userId;
        // Check Role based acces for the manage users landing page
        // Rights Ids :: ModuleId = 4
        manageUserRights = userDetails.Rights.filter(x => x.module_id == 4);
        manageUserRightsAccess = manageUserRights[0].access;
        manageUserRightsModuleId = manageUserRights[0].module_id;

        //Check globale user
        rightsDetails = userDetails.Rights.filter(x => x.module_id == 8);
        BRANCH_ID = userDetails.UserContext.locationId;
        RIGHT_ACCESS = rightsDetails[0].access;
        MODULE_ID = rightsDetails[0].module_id;
        GLOBAL_USER = "N";
        if (RIGHT_ACCESS == 1 && MODULE_ID == 8) {
            GLOBAL_USER = "Y";
        }

        this.props.actions.fetchLookupData(FIRM_ID).then(() => {
            this.props.fetchActiveCategories(FIRM_ID)
                .then((res) => {
                    //console.log("after call ", res.payload.categoryData)
                    this.fetchUsers(FIRM_ID, BRANCH_ID, GLOBAL_USER, res.payload.categoryData);
                });
        });
    }

    componentWillUnmount() {
        this.props.actions.clearAllUsers();
    }

    fetchUsers(firmId, branchId, globalUser, categories) {
        //console.log("###############fetching users")
        this.props.actions.getAllUsers(
            firmId,
            branchId,
            globalUser,
            this.props.lookup,
            categories
        );
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.isEventBySelectAll) {
            this.isEventBySelectAll = false;
            return false;
        }
        if (!nextProps.allUsers.length) {
            return false;
        }

        if (nextProps.isExport) {
            this.exportToExcel();
            return false;
        }
        if (nextProps.isClearFilters) {
            this.handleClearFilters();
            return false;
        }

        if (nextProps.isSortSelectedUsers) {
            this.sortSelectedUsersToTop();
        }
        return true;
    }

    componentDidUpdate(prevProps, prevState) {
        //console.log("componentDidUpdate");
        // console.log("componentDidUpdate", prevProps, prevState);
    }

    updateColumn(column) {
        if (column.selector && column.selectOptions.data == null) {
            let categories = this.props.categories.map(el => {
                return {
                    firm_id: el.firm_id,
                    defaultCategory_id: el.category_id,
                    defaultCategory_name: el.name
                }
            })
            let lookup = this.props.lookup;
            lookup.defaultCategory = categories;
            column.selectOptions.data = setDropdownValues({
                data: lookup,
                defaults: DEFAULTS,
                selector: column.selector,
                properties: column.properties
            });
        }
    }

    runForAllCoumns() {
        this.columns.forEach(column => this.updateColumn(column));
    }

    // Inline Grid Save Button Click..
    async onSaveChanges() {
        if (this.props.lookup.ActiveUsersCount >= this.props.lookup.LicenseCount) {
            if (this.state.activatedUsersList !== undefined && this.state.activatedUsersList.length > 0) {
                this.props.actions.discardChanges();
                this.state.activatedUsersList = [];
                this.setState({ showLicenseError: true });
                return;
            }
        }

        this.props.actions.resetLoading(true);
        let inlineUpdatedUserData = {};
        let updatedData = this.props.updatedUsers;
        let {
            firmBranches,
            department,
            rightsGroupNames,
            pageDetails,
            titleLevelList,
            industry,
            nicheGroups,
            expertise,
            rolesDetails
        } = this.props.lookup;

        //console.log("FROM ON SAVE : ", this.props.lookup, updatedData)
        let allCategories = this.props.categories;
        let finalUpdatedData = updatedData.map(el => {
            el.account_disabled = el.account_disabled == "Inactive" ? "Y" : "N";
            //branch name
            let userBranch = firmBranches.find(
                loc => el.branch_name === loc.branch_name
            );
            el.branch_id = userBranch ? userBranch.branch_id : "";

            let selectedCat = allCategories.find(cat => cat.name == el.default_category)
            if (selectedCat) {
                el.defaultCategory = selectedCat.category_id;
            } else {
                el.defaultCategory = 0;
            }
            //Task Locations
            let taskLocationsList = el.task_location_names.split("|");
            let taskLocations = firmBranches.filter(loc => {
                return taskLocationsList.includes(loc.branch_name.toString());
            });
            el.task_Locations = taskLocations.map(tl => tl.branch_id).join(",");

            //departments
            let userDepartmentsList = el.department_names.split("|");
            let userDepartments = department.filter(dep => {
                return userDepartmentsList.includes(dep.department_name.toString());
            });
            el.department = userDepartments.map(d => d.department_id).join(",");

            // Pinned views for MyView
            if (el.pinned_views_for_myview != null) {
                let pinnedViewsForMyviewList = el.pinned_views_for_myview.split("|");
                let pinnedViewsForMyview = [];
                pinnedViewsForMyviewList.map(_pinnstr => {
                    return pageDetails.filter(pv => {
                        //return pinnedViewsForMyviewList.includes(pv.Bucketname.toString());
                        if (pv.Bucketname.toString() === _pinnstr) pinnedViewsForMyview.push(pv);
                    });
                })

                el.page_id = !pinnedViewsForMyview.length ? "1" : pinnedViewsForMyview.map(e => e.Bid).join(",");
            }

            // Default MyView View
            let defaultMyView = pageDetails.find(
                df => el.default_myview_name === df.Bucketname
            );
            el.LandingPageId = defaultMyView ? defaultMyView.Bid : "";
            //  Add Default MyView View value as first value in Pinned views for MyView
            let _landingPage = el.LandingPageId.toString();
            let myView = _landingPage
                ? el.page_id
                    ? _landingPage.concat(",", el.page_id)
                    : _landingPage
                : el.page_id;
            el.page_id = [...new Set(myView.split(","))].join();

            // userRightGroupNames
            let rightsGroupNamesList = el.belongsto_group_names.split("|");
            let userRightGroupNames = rightsGroupNames.filter(group => {
                return rightsGroupNamesList.includes(group.Group_name.toString());
            });
            el.belongsto_group = userRightGroupNames.map(el => el.Group_id).join(",");

            //title level
            let titleLevel = titleLevelList.find(
                title =>
                    el.title_or_level_names.toString() ===
                    title.titleORlevel_name.toString()
            );
            el.title_level = titleLevel ? titleLevel.titleORlevel_id : "";

            //niche_group
            let nicheGroupList = el.niche_or_group_names.split("|");
            let userNicheGroups = nicheGroups.filter(niche => {
                return nicheGroupList.includes(niche.nicheORgroup_name.toString());
            });
            el.niche_group = userNicheGroups.map(el => el.nicheORgroup_id).join(",");

            //Industry Group
            let industryList = el.industry_names.split("|");
            let userIndustries = industry.filter(ind => {
                return industryList.includes(ind.industry_name.toString());
            });
            el.industry_group = userIndustries.map(el => el.industry_id).join(",");

            // expertise
            let expertiseList = el.expertise_names.split("|");
            let userExpertise = expertise.filter(exp => {
                return expertiseList.includes(exp.expertise_name.toString());
            });
            el.expertise = userExpertise.map(el => el.expertise_id).join(",");

            //primary role

            let primaryRole = rolesDetails.find(
                role => el.primary_role_name.toString() === role.role_name.toString()
            );
            el.primary_role = primaryRole ? primaryRole.role_id : "";

            //secondary role

            let secondaryRole = rolesDetails.find(
                role => el.secondary_role_name.toString() === role.role_name.toString()
            );
            el.secondary_role = secondaryRole ? secondaryRole.role_id : "";

            // work exp begindate

            //Wrk_Exp_Begindate
            // let workExp = moment(el.wrk_exp_begindate, "YYYY-MM-DDThh:mm:ss");
            el.wrk_exp_begindate = el.wrk_exp_begindate
                ? el.wrk_exp_begindate
                : "1900-01-01T00:00:00";

            //loginUserId
            el.loggedUserId = logginedUser;

            //phone number
            let phoneNum = el.phone_number;
            el.phone_number = phoneNum;

            return el;
        });

        inlineUpdatedUserData.UserList = finalUpdatedData;

        const request = await usersServices.req.saveGridChanges(
            API.updateUsersInGrid,
            inlineUpdatedUserData
        );
        //console.log("finalUpdatedData", finalUpdatedData)
        if (request) {

            if (!request.isSuccess) {
                const notification = {
                    message: request.msg,
                    type: NOTIFICATION_TYPE_ERROR,
                    duration: 5000,
                    canDismiss: true,
                    showCloseAllBtn: true
                };
                this.props.createNotification(notification);
                this.props.actions.resetLoading(false);
                this.props.actions.discardChanges();
                this.state.activatedUsersList = [];
                return;
            }
            this.disableHeaderCheckBox(false);
            this.props.actions.gridUpdate([], false, false, this.props.allUsers);
            // this.props.actions.getAllUsers(
            //   FIRM_ID,
            //   BRANCH_ID,
            //   GLOBAL_USER,
            //   this.props.lookup,
            // );
            const mySuccessNotification = {
                message: "Inline grid update successful",
                type: NOTIFICATION_TYPE_SUCCESS,
                duration: 5000,
                canDismiss: true,
                showCloseAllBtn: true
            };
            
            this.props.createNotification(mySuccessNotification);
        }
    }

    // showCancelModal() {
    //   this.props.actions.showModalToDiscard(true);
    // }

    discardChangesYes() {

        const mySuccessNotification = {
            message: "Changes discarded successfully",
            type: NOTIFICATION_TYPE_SUCCESS,
            duration: 5000,
            canDismiss: true,
            showCloseAllBtn: true
        };
        this.disableHeaderCheckBox(false);
        this.props.actions.discardChanges();
        this.state.activatedUsersList = [];
        this.props.createNotification(mySuccessNotification);

    }
    // discardChangesNo() {
    //    this.props.actions.showModalToDiscard(false);
    // }

    showLoader() {
        return (
            <Dimmer page active inverted>
                <Loader inverted>Loading</Loader>
            </Dimmer>
        );
    }
    handleClosemessage = () => {
        this.setState({ showLicenseError: false });
    }

    beforeRowRenderHandler(TD, row, column, prop, value, cellProperties) {
        const parentElement = TD.parentElement;
        if (parentElement === null) return;

        if (cellProperties.instance.getDataAtCell(row, 0)) {
            Handsontable.dom.addClass(parentElement, "selected");
        } else {
            Handsontable.dom.removeClass(parentElement, "selected");
        }
    };

    render() {
        var userDetails = atob(localStorage.getItem("userDetails"));

        if (
            !userDetails ||
            (manageUserRightsAccess == 0 && manageUserRightsModuleId == 4)
        ) {
            return (
                <Redirect
                    to={{
                        pathname: "/webapp/notauth",
                        state: { from: this.props.location }
                    }}
                />
            );
        }
        if (Object.keys(this.props.lookup).length) {
            this.runForAllCoumns();
        }

        return (
            <Fragment>
                {!this.props.allUsers.length || this.props.isLoading
                    ? this.showLoader()
                    : ""}
                <HotTable
                    className="usertable"
                    ref={this.hotTableComponent}
                    settings={this.settings}
                    data={this.props.allUsers}
                    colHeaders={colHeaders}
                    colWidths={colWidths}
                    columns={this.columns}
                    beforeChange={this.onBeforeHotChange.bind(this)}
                    afterChange={this.afterChangeHandler.bind(this)}
                    afterFilter={this.afterFilterHandler.bind(this)}
                    afterLoadData={this.afterLoadDataHandler.bind(this)}
                    afterOnCellMouseDown={this.afterOnCellMouseDownHandler.bind(this)}
                    beforeKeyDown={event => {
                        if (event.keyCode === 46 || event.keyCode === 8) {
                            event.stopImmediatePropagation();
                        }
                    }}
                    beforeRenderer={this.beforeRowRenderHandler.bind(this)}
                    width="100%"
                    height="calc(100vh - 185px)"
                />
                {this.props.lookup.ActiveUsersCount >= this.props.lookup.LicenseCount && this.state.showLicenseError ? (
                    <WarningMessageWithCloseOption textAlign="right" eventCloseMessage={this.handleClosemessage} message={"You have reached the maximum number of active users allowed by your license. Contact your sales representative to add more users to your license, or reduce the number of active users."} />)
                    : ("")}
                {this.props.isEdited ? (
                    <Grid padded textAlign="right">
                        <Grid.Row columns={2}>
                            <Grid.Column textAlign="left">

                            </Grid.Column>
                            <Grid.Column>
                                <Modal
                                    className="confirmModal"
                                    trigger={<Button>Cancel</Button>}
                                    closeIcon
                                    size="small"
                                    header={{ content: "Warning" }}
                                    content="The changes you have made will be deleted. Do you want to proceed?"
                                    actions={[
                                        {
                                            key: 1,
                                            basic: true,
                                            fluid: true,
                                            color: "red",
                                            inverted: true,
                                            content: "No",
                                            triggerclose: "true"
                                        },
                                        {
                                            key: 2,
                                            basic: true,
                                            color: "green",
                                            fluid: true,
                                            inverted: true,
                                            content: "Yes",
                                            triggerclose: "false",
                                            onClick: this.discardChangesYes.bind(this)
                                        }
                                    ]}
                                />
                                <Button
                                    primary
                                    content="Save Changes"
                                    onClick={this.onSaveChanges.bind(this)}
                                    title="Save Changes"
                                />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                ) : (
                    <Grid.Row />
                )}

                {/* <Modal open={this.props.isModalOpen} size="tiny">
          <Modal.Header>Warning  <Icon
            className="xcm-icon-remove j_remove_rightalign"
            size="small"
            style={{ cursor: "pointer" }}
            onClick={this.discardChangesNo.bind(this)}
          /></Modal.Header>
          <Modal.Content>
            <p>The changes you have made will be deleted. Do you want to proceed?</p>
          </Modal.Content>
          <Modal.Actions className="j_leftaction">
            <Button.Group size='medium' className="j_group_medium_width">
              <Button basic inverted fluid
                onClick={this.discardChangesNo.bind(this)}
                color="red" >No</Button>
              <Button
                basic inverted fluid
                color="green"
                content='Yes'
                onClick={this.discardChangesYes.bind(this)}
              />
            </Button.Group>
          </Modal.Actions>
        </Modal> */}
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        allUsers: state.userReducer.allUsers,
        lookup: state.userReducer.lookupData,
        isLoading: state.userReducer.isLoading,
        //loading: state.userReducer.loading,
        //error: state.userReducer.error,
        selectedUsersIds: state.userReducer.selectedUsers.selectedUsersIds,
        selectedUsersStatus: state.userReducer.selectedUsers.selectedUsersStatus,
        updatedUsers: state.userReducer.updatedUsers,
        isEdited: state.userReducer.isEdited,
        bulkUpdatedUsers: state.userReducer.bulkUpdatedUsers,
        isExport: state.userReducer.isExport,
        isClearFilters: state.userReducer.isClearFilters,
        //isModalOpen: state.userReducer.isModalOpen,
        // showFilterIcon: state.userReducer.showFilterIcon,
        createNotification: state.userReducer.createNotification,
        isSortSelectedUsers: state.userReducer.isSortSelectedUsers,
        categories: state.allCategories.activeCategories
        // filterUserStatus: state.userReducer.filterUserStatus
    };
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch),
    createNotification: config => {
        dispatch(createNotification(config));
    },
    fetchActiveCategories: () => dispatch(fetchActiveCategories(FIRM_ID))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserTable);
